<template>
  <div
    class="buyBox"
  >
    <div>
      <div class="headline-availability">
        <h2
          class="h4"
        >
          {{ loginHeadline }}
        </h2>
      </div>

      <p class="mt--1">
        {{ loginText }}
      </p>
      <div
        v-if="!isDefaultCustomer"
        class="btn-newpdp"
      >
        <kbutton
          @click="login()"
          :theme-color="'base'"
          class="subline anchor"
        >
          {{ $tv('Login') }}
        </kbutton>
      </div>
    </div>
    <div>
      <h2 class="urgent-demand-headline h4">
        {{ urgentDemandHeadline }}
      </h2>
      <p class="subline">
        {{ urgentDemandText }}
      </p>
      <div class="btn-newpdp">
        <kbutton
          :theme-color="'base'"
          @click="handleClick"
        >
          <nuxt-link
            class="anchor"
          >
            {{ urgentDemandButtonText }}
          </nuxt-link>
        </kbutton>
      </div>
    </div>
  </div>
</template>

<script>
import {Button} from '@progress/kendo-vue-buttons'
import {useGtm} from '@gtm-support/vue-gtm'

export default {
  name: 'LoginAndUrgentDemand',
  components: {
    kbutton: Button
  },
  props: {
    isDefaultCustomer: {
      type: Boolean,
      default() {
        return false
      }
    },
    product: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  // TODO: change the key to a generic one (without region) #41279
  computed: {
    loginHeadline() {
      return this.$tv('login.headline.na', 'buyBoxAnonymous')
    },
    loginText() {
      return this.$tv('login.text.na', 'buyBoxAnonymous')
    },
    urgentDemandHeadline() {
      return this.$tv('urgentDemand.headline.na', 'buyBoxAnonymous')
    },
    urgentDemandText() {
      return this.$tv('urgentDemand.text.na', 'buyBoxAnonymous')
    },
    urgentDemandButtonText() {
      return this.$tv('urgentDemand.buttonText.na', 'buyBoxAnonymous')
    }
  },
  methods: {
    login() {
      navigateTo({path: '/auth/login'})
    },
    handleClick() {
      this.$eventbus.emit('showContactPopup')
      this.trackContactUsClick()
    },
    trackContactUsClick() {
      useGtm()?.trackEvent({
        event: 'partnerh_askus',
        category: 'partner_hub',
        ecommerce: {
          sku: this.product?.sku
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.buyBox {
  .headline-availability {
    .h4 {
      margin: 0 0 1rem;
    }
  }

  .btn-newpdp {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
  }

  &__loggedInContent {
    margin-bottom: 5em;

    &--opacity {
      opacity: .5;
    }
  }

  .k-button {
    width: 9.1em;
  }

  .anchor {
    text-decoration: none;
    color: $color__white;
    font-weight: $base-text-font-weight-semi-bold;
  }

  .urgent-demand-headline {
    margin: 2rem 0 1rem;
  }
}
</style>
